var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"px-4",attrs:{"color":"grey lighten-2","loading":_vm.loading,"disabled":_vm.disabled}},[_vm._v(" "+_vm._s(_vm.$t("action_texts.close"))+" "),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v(" mdi-keyboard-return ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }